import { useEffect, useState } from 'react';
import { fetchBlob } from '../core/api.js';

interface Props {
  path: string;
  alt: string;
  className?: string;
  onClick?: () => void;
}

/**
 * Yetki gerektiren bir görseli gösterir.
 *
 * Kayıt fotoğrafları oturum kontrolünden geçiyor; `img` etiketi istek
 * başlığı gönderemediği için içerik önce indirilip nesne URL'ine çevriliyor.
 */
export function AuthImage({ path, alt, className, onClick }: Props) {
  const [url, setUrl] = useState<string | null>(null);
  const [hata, setHata] = useState(false);

  useEffect(() => {
    let iptal = false;
    let olusan: string | null = null;

    void fetchBlob(path)
      .then((blob) => {
        if (iptal) return;
        olusan = URL.createObjectURL(blob);
        setUrl(olusan);
      })
      .catch(() => {
        if (!iptal) setHata(true);
      });

    return () => {
      iptal = true;
      // Nesne URL'i bırakılmazsa liste kaydırıldıkça bellek şişer.
      if (olusan) URL.revokeObjectURL(olusan);
    };
  }, [path]);

  if (hata) return <span className="gorsel-yok">✕</span>;
  if (!url) return <span className="gorsel-yukleniyor" />;

  return <img src={url} alt={alt} className={className} onClick={onClick} />;
}
